'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import UISelect from 'UIComponents/input/UISelect';
import I18n from 'I18n';
import SlackAPI from '../utils/SlackAPI';
import Alerts from '../utils/alerts';
import SlackResponseStatusDeterminer from '../utils/SlackResponseStatusDeterminer';
import { jsx as _jsx } from "react/jsx-runtime";
const I18N_ALERTS = 'slackUiLibrary.shareToSlackSidePanel.alerts';
class SlackChannelSelect extends Component {
  constructor(props) {
    super(props);
    this.mapSlackChannelToOption = channel => {
      return {
        text: `#${channel.name}`,
        value: channel.id
      };
    };
    this.loadSlackChannelOptions = (searchInputValue, callback) => {
      const {
        hasMore,
        nextCursor,
        lastQueriedChannelName
      } = this.state;
      if (searchInputValue.includes(lastQueriedChannelName) && !hasMore) {
        callback(null, this.searchAmongAlreadyFetchedChannels(searchInputValue));
        return;
      }
      const isInputChanged = lastQueriedChannelName !== searchInputValue;
      const nextCursorToCallWith = isInputChanged ? null : nextCursor;
      SlackAPI.searchChannels(searchInputValue, nextCursorToCallWith).then(this.processSearchChannelsResult(isInputChanged, searchInputValue, callback)).catch(() => this.handleChannelsFetchingError());
    };
    this.handleSelectedChannelUpdate = evt => {
      const channelId = evt.target.value;
      this.props.onChange(channelId);
    };
    this.state = {
      slackChannelOptions: [],
      nextCursor: null,
      hasMore: true,
      lastQueriedChannelName: ''
    };
  }
  processSearchChannelsResult(isInputChanged, searchInputValue, callback) {
    return response => {
      if (SlackResponseStatusDeterminer.isErrorResponse(response)) {
        this.handleChannelsFetchingError(response);
        return;
      }
      const nextCursor = response.nextCursor;
      let newSlackChannelOptions = response.channels.map(this.mapSlackChannelToOption);
      if (!isInputChanged) {
        newSlackChannelOptions = [...this.state.slackChannelOptions, ...newSlackChannelOptions];
      }
      const hasMoreSlackChannelsToFetch = nextCursor != null;
      this.setState({
        slackChannelOptions: newSlackChannelOptions,
        hasMore: hasMoreSlackChannelsToFetch,
        nextCursor,
        lastQueriedChannelName: searchInputValue
      });
      callback(null, {
        options: newSlackChannelOptions,
        pagination: {
          hasMore: hasMoreSlackChannelsToFetch
        }
      });
    };
  }
  searchAmongAlreadyFetchedChannels(searchInputValue) {
    return {
      options: this.state.slackChannelOptions.filter(this.filterOptionByTextIncludes(searchInputValue)),
      pagination: {
        hasMore: false
      }
    };
  }
  filterOptionByTextIncludes(searchInputValue) {
    return option => {
      const channelNameWithoutNumberSign = option.text.substring(1);
      return channelNameWithoutNumberSign.toLowerCase().includes(searchInputValue);
    };
  }
  handleChannelsFetchingError(error) {
    let errorId;
    let title;
    let message;
    if (SlackResponseStatusDeterminer.isInvalidAuthError(error)) {
      errorId = `authError`;
      title = `${I18N_ALERTS}.general.invalidAuth.title`;
      message = `${I18N_ALERTS}.general.invalidAuth.message`;
    } else if (SlackResponseStatusDeterminer.isThirdPartyOutageError(error)) {
      this.props.setSlackOutageStatus(true);
      return;
    } else {
      errorId = `defaultChannelsFetchingError`;
      title = `${I18N_ALERTS}.channelsFetching.error.general.title`;
      message = `${I18N_ALERTS}.channelsFetching.error.general.message`;
    }
    Alerts.displayErrorAlert(errorId, title, message);
  }
  render() {
    return /*#__PURE__*/_jsx(UISelect, {
      cache: false,
      onChange: this.handleSelectedChannelUpdate,
      disabled: this.props.disabled,
      placeholder: I18n.text('slackUiLibrary.shareToSlackSidePanel.channelsSelector.placeholder'),
      searchPlaceholder: I18n.text('slackUiLibrary.shareToSlackSidePanel.channelsSelector.searchPlaceholder'),
      loadOptions: this.loadSlackChannelOptions
    });
  }
}
SlackChannelSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  setSlackOutageStatus: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};
export default SlackChannelSelect;